import {styled} from '@mui/material'
import {FormErrorMessage} from 'components/Control/Form'
import FormImageUpload from 'components/Control/Form/FormImageUpload'
import FormInput from 'components/Control/Form/FormInput'
import FormSelect from 'components/Control/Form/FormSelect'
import {familyStatuses, genderKod} from 'constants/users'
import {useDeviceDetect} from 'services/hooks'
import {preventNegativeAndFloats} from 'services/utils/formUtils'
import {formatKeyFunctionsByType} from 'services/utils/tables'
import {useI18n} from 'store/Store'
//

const NewClientForm = ({formControl, formErrors, errorMessage, spouseName}) => {
    const {i18n} = useI18n()
    const {isMobile} = useDeviceDetect()

    console.log('form error message', errorMessage)
    return (
        <Container>
            <FormErrorMessage errorMessage={errorMessage} />
            <FormContainer isMobile={isMobile}>
                <Column>
                    <FormInput
                        required
                        name="ClientFirstName"
                        label={i18n.t('clients.ClientFirstName')}
                        control={formControl}
                        formErrors={formErrors}
                        style={{flex: 3}}
                    />
                    <FormInput
                        required
                        name="ClientLastName"
                        label={i18n.t('clients.ClientLastName')}
                        control={formControl}
                        formErrors={formErrors}
                        style={{flex: 3}}
                    />
                    <FormInput
                        required
                        name="ClientPhone"
                        label={i18n.t('clients.ClientPhone')}
                        control={formControl}
                        formErrors={formErrors}
                        style={{flex: 3}}
                    />
                    <FormInput
                        required
                        name="ClientEmail"
                        label={i18n.t('clients.ClientEmail')}
                        control={formControl}
                        formErrors={formErrors}
                        style={{flex: 3}}
                    />
                    <FormInput
                        required
                        name="ClientId"
                        label={i18n.t('clients.ClientId')}
                        control={formControl}
                        formErrors={formErrors}
                        style={{flex: 3}}
                    />

                    <FormImageUpload
                        name="ClientIdPhoto"
                        label={i18n.t('clients.ClientIdPhoto')}
                        control={formControl}
                        formErrors={formErrors}
                        style={{flex: 3}}
                    />
                </Column>
                <Column>
                    <FormSelect
                        itemName="users"
                        name="GenderKod"
                        label={i18n.t('clients.GenderKod')}
                        control={formControl}
                        formErrors={formErrors}
                        options={Object.keys(genderKod)}
                        format={(value) =>
                            formatKeyFunctionsByType().gender(value, i18n)
                        }
                        selectWidth="60%"
                        style={{flex: 3}}
                    />
                    <FormSelect
                        itemName="users"
                        name="FamilyStatus"
                        label={i18n.t('clients.FamilyStatus')}
                        control={formControl}
                        formErrors={formErrors}
                        options={Object.keys(familyStatuses)}
                        format={(value) =>
                            formatKeyFunctionsByType().familyStatus(value, i18n)
                        }
                        selectWidth="60%"
                        style={{flex: 3}}
                    />

                    <FormInput
                        name="ChildrenNumber"
                        label={i18n.t('clients.ChildrenNumber')}
                        control={formControl}
                        formErrors={formErrors}
                        type="number"
                        onKeyPress={preventNegativeAndFloats}
                        style={{flex: 3}}
                    />

                    <FormInput
                        name="SpouseName"
                        label={i18n.t('clients.spouse')}
                        control={formControl}
                        formErrors={formErrors}
                        style={{flex: 3}}
                    />

                    <FormInput
                        name="WorkName"
                        label={i18n.t('clients.WorkName')}
                        control={formControl}
                        formErrors={formErrors}
                        style={{flex: 3}}
                    />

                    <FormInput
                        name="Profession"
                        label={i18n.t('clients.Profession')}
                        control={formControl}
                        formErrors={formErrors}
                        style={{flex: 3}}
                    />
                </Column>
            </FormContainer>
            {/* removing for now */}
            {/* <BottomActions>
                <Button
                    color="secondary"
                    startIcon={<CopyAllOutlinedIcon fontSize="24px" />}
                    style={{fontWeight: 'bold', fontSize: 16}}>
                    {i18n.t('clients.copyNewRequest')}
                </Button>
                <Checkbox
                    color="secondary"
                    defaultChecked
                    label={i18n.t('clients.requestDetails')}
                />
            </BottomActions> */}
        </Container>
    )
}

export default NewClientForm

const Container = styled('div')`
    display: flex;
    flex-direction: column;
    height: 100%;
`

const FormContainer = styled('div')`
    display: flex;
    flex-direction: ${({isMobile}) => (isMobile ? 'column' : 'row')};
    gap: ${({isMobile}) => (isMobile ? 28 : 100)}px;
    height: 100%;
    padding: ${({isMobile}) => (isMobile ? 20 : 48)}px;
`

const Column = styled('div')`
    display: flex;
    flex-direction: column;
    flex: 1;
    gap: 28px;
`

// const BottomActions = styled('div')`
//     margin: 0 48px;
// `

// const FormLabel = styled(Texts.BoldText)`
//     font-size: 16px;
//     flex: 1;
// `
